// What the landing page says, and what `index.html` says, as one thing.
//
// **The crawlable copy lives in `index.html`** inside `<div id="root">`, where
// `createRoot` throws it away on mount — that is what a crawler and an unfurler
// read, and it is the reason this domain ranks for anything at all. The landing
// page is what a *person* sees a moment later, and if the two disagreed we
// would have the two-descriptions-of-one-game problem the SEO handoff spent a
// section refusing.
//
// So the sentences are here, and `server/discoverability.test.ts` asserts that
// `index.html` still contains the lede. They cannot drift without a test going
// red.

/** The one-sentence claim, identical to the boot copy's opening paragraph. */
export const LEDE =
  "Chess played on the same sixty-four squares as a working factory. " +
  "Captured pieces leave scrap; pawns mine it, belts haul it, bishops " +
  "refine it and rooks smelt it into new pieces.";

export interface Section {
  heading: string;
  body: string;
}

/** The same four points the boot copy makes, in the same order. */
export const SECTIONS: readonly Section[] = [
  {
    heading: "It is still chess",
    body:
      "The same board, the same pieces, the same moves, the same checkmate. " +
      "You could play a whole game and never build anything. But every piece " +
      "is also a machine, and the board is also a factory floor."
  },
  {
    heading: "Where the material comes from",
    body:
      "Nothing is on the board at the start. Every unit of it comes from a " +
      "capture: take a piece and its wreckage stays on the square it died on. " +
      "The economy cannot open before the war does."
  },
  {
    heading: "Industry costs ground, not tempo",
    body:
      "A turn is one chess move plus as much construction as you like. What " +
      "limits you is reach — you build only beside your own pieces — and " +
      "cobble, three to each belt part, built the moment it is laid."
  }
];

/** What the sign-in button says, in one place because two screens show it. */
export const SIGN_IN = "Continue with Google";
